import { css } from '@emotion/css';
import { mobileMediaQuery, nonMobileMediaQuery } from '@snapchat/snap-design-system-marketing';

export const mediaStylesCss = css`
  max-width: 100%;
  max-height: 400px;

  /* only do non mobile for now as we break rendering images that are very wide */
  ${nonMobileMediaQuery} {
    &.strict-height {
      height: var(--mediaHeight);
    }
  }
`;

export const mediaOnlyCss = css`
  margin-bottom: inherit;
  max-height: 600px;

  ${nonMobileMediaQuery} {
    &.strict-height {
      height: var(--mediaHeight);
    }
  }

  ${mobileMediaQuery} {
    max-width: 100%;
    height: inherit;
  }
`;

export const videoCss = css`
  /* Unlike images, videos will always expand to the width of their container. The benefits are two fold...

   1. We don't have to worry about the poster image being a different size than the video.
   2. We don't have to worry about different video resolutions (but same aspect ratio) rendering as different sizes.

  */
  width: 100%;
`;
